const dataReducer = (state = { evidenceData: null }, action) => {
    switch (action.type) {
        case 'STORE_TRANSFORMED_EVIDENCE_DATA':
            return { ...state, evidenceData: action.payload };
        case 'INFRACTION_SELECTED':
            return { ...state, infractionClicked: action.payload };
        case 'TRAFFIC_INFRACTION_LIST_UPDATED':
            return { ...state, trafficInfractionList: action.payload };
        case 'MUNICIPAL_INFRACTION_LIST_UPDATED':
            return { ...state, municipalInfractionList: action.payload };
        case 'TOGGLE_OFF_VIDEO_SECTION':
            return { ...state, toggleOffVideoSection: action.payload };
        case 'STORE_TRANSFORMED_MUNICIPAL_DATA':
            return {...state, municipalData: action.payload};
        case 'STORE_TRANSFORMED_ROAD_SIGN_DATA':
            return {...state, roadSignData: action.payload};
        case 'TOGGLE_SHOW_DROP_DOWN_FILTERS':
            return { ...state, canLoadDropDownBool: action.payload };
        case 'SHOW_WARD_DROPDOWN':
            return { ...state, remountWardDropDown: action.payload };
        case 'SHOW_WELCOME_MODAL':
            return { ...state, showWelcomeModal: action.payload };
      default:
        return state;
    }
};

export default dataReducer;